import React from "react";

import { Drawer as AntDrawer } from "antd";

import { Icon } from "components";

export const CourseOverlay = ({ centerHeader = false, children, className = "", footer, title, visible, onClose = () => {} }) => {
  const headerStyle = {
    textAlign: centerHeader ? "center" : "left",
  };

  return (
    <AntDrawer
      className={`klim-overlay full-height ${footer ? "has-footer" : ""} ${className}`}
      closeIcon={<Icon iconName="tabler/x" size="m" />}
      footer={footer}
      height="100vh"
      headerStyle={headerStyle}
      placement="bottom"
      title={<h4>{title}</h4>}
      width="100vw"
      open={visible}
      onClose={onClose}
    >
      {children}
    </AntDrawer>
  );
};
